import * as yup from 'yup';

const truckingCompanySchema = yup.object().shape({
  company: yup.string().trim().required('Name is required!'),
  code: yup.string().trim().required('SCAC code is required!'),
});

export default truckingCompanySchema;
